"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringArray = exports.isString = exports.isNumber = void 0;
var lodash_1 = __importDefault(require("lodash"));
function isNumber(x) {
    return typeof x === 'number';
}
exports.isNumber = isNumber;
function isString(x) {
    return typeof x === 'string';
}
exports.isString = isString;
function isStringArray(value) {
    return value instanceof Array && lodash_1.default.every(lodash_1.default.map(value, isString));
}
exports.isStringArray = isStringArray;
//# sourceMappingURL=TypeUtils.js.map